
const ruleCN = (rule, value, callback) => {
  const reg = new RegExp('^[\u4e00-\u9fa5]+$');
  if (!value) {
    if (rule.field === 'surname_cn') return callback(new Error('请填写姓（中文）'));
    if (rule.field === 'name_cn') return callback(new Error('请填写名（中文）'));
    if (rule.field === 'fullname') return callback(new Error('请填写姓名（中文）'));
  } else if (!reg.test(value)) {
    return callback(new Error('格式错误，请重新填写'));
  }
  callback();

};
const ruleEN = (rule, value, callback) => {
  const reg = new RegExp('^[a-zA-Z]+$');
  if (!value) {
    if (rule.field === 'surname_pinyin') return callback(new Error('请填写姓（拼音）'));
    if (rule.field === 'name_pinyin') return callback(new Error('请填写名（拼音）'));
  } else if (!reg.test(value)) {
    return callback(new Error('格式错误，请重新填写'));
  }
  callback();

};
const passportNumber = (rule, value, callback) => {
  const reg = new RegExp('^[A-Z0-9]{5,12}$');

  if (!value) {
    return callback(new Error('请填写护照号码'));
  } else if (!reg.test(value)) {
    if (value.length > 12) {
      return callback(new Error('护照号位数太长'));
    }
    return callback(new Error('格式错误，请重新填写'));
  }
  callback();

};
const idcardNumber = (rule, value, callback) => {
  const reg = /^\d{15}$|^\d{17}\S$/;
  if (!value) {
    return callback(new Error('请填写身份证号码'));
  } else if (!value.match(reg)) {
    return callback(new Error('格式错误，请重新填写'));
  }
  callback();

};

export default{

  passportRules: {
    surname_cn: [
      { validator: ruleCN, trigger: 'blur,change' },
    ],
    name_cn: [
      { validator: ruleCN, trigger: 'blur,change' },
    ],
    surname_pinyin: [
      { validator: ruleEN, trigger: 'blur,change' },
    ],
    name_pinyin: [
      { validator: ruleEN, trigger: 'blur,change' },
    ],
    gender: [
      { required: true, message: '请选择性别', trigger: 'change', type: 'number' },
    ],
    birthday: [
      { required: true, message: '请选择出生日期', trigger: 'change' },
    ],
    passport_number: [
      { validator: passportNumber, trigger: 'blur' },
    ],
    issue_date: [
      { required: true, message: '请选择签发日期', trigger: 'change' },
    ],
    expire_date: [
      { required: true, message: '请选择有效期', trigger: 'change' },
    ],
    birth_place_cn: [
      { required: true, message: '请选择出生地点', trigger: 'change' },
    ],
    other_birth_place_cn: [
      { required: true, message: '请选择其它出生地点', trigger: 'change,blur' },
    ],
    birth_place_pinyin: [
      { required: true, message: '请选择出生地点（英文）', trigger: 'change' },
    ],
    other_birth_place_pinyin: [
      { required: true, message: '请选择其它出生地点（英文）', trigger: 'change,blur' },
    ],
    issue_place_cn: [
      { required: true, message: '请选择签发地点', trigger: 'change' },
    ],
    other_issue_place_cn: [
      { required: true, message: '请选择其它签发地点', trigger: 'change,blur' },
    ],
    issue_place_pinyin: [
      { required: true, message: '请选择签发地点（英文）', trigger: 'change' },
    ],
    other_issue_place_pinyin: [
      { required: true, message: '请选择其它签发地点（英文）', trigger: 'change,blur' },
    ],
    issue_authority_cn: [
      { required: true, message: '请填写签发机关', trigger: 'change,blur' },
    ],
    issue_authority_en: [
      { required: true, message: '签发机关英文', trigger: 'change,blur' },
    ],
  },
  passportForeignRules: {
    country_code: [
      { required: true, message: '请选择国籍' },
    ],
    name_pinyin: [
      { pattern: /^[a-zA-Z ]+$/, required: true, message: '请填写正确的名（英文）' },
    ],
    surname_pinyin: [
      { pattern: /^[a-zA-Z ]+$/, required: true, message: '请填写正确的姓（英文）' },
    ],
    
    passport_number: [
      { pattern: /^[A-Z0-9]{5,12}$/, required: true, message: '请填写正确的护照号码' },
    ],
    gender: [
      { required: true, message: '请选择性别', type: 'number' },
    ],
    birthday: [
      { required: true, message: '请选择出生日期' },
    ],
    issue_date: [
      { required: true, message: '请选择签发日期' },
    ],
    expire_date: [
      { required: true, message: '请选择有效期' },
    ],
    birth_place_pinyin: [
      { required: false, message: '请选择出生地点（英文）' },
    ],
    issue_place_pinyin: [
      { required: false, message: '请选择签发地点（英文）' },
    ],
  },
  idcardaRules: {
    fullname: [
      { validator: ruleCN, trigger: 'blur,change' },
    ],
    id_no: [
      { validator: idcardNumber, trigger: 'blur' },
    ],
    gender: [
      { required: true, message: '请选择性别', trigger: 'change', type: 'number' },
    ],
    nation: [
      { required: true, message: '请选择民族', trigger: 'change' },
    ],
    birthday: [
      { required: true, message: '请选择出生日期', trigger: 'change' },
    ],
    address: [
      { required: true, message: '请填写住址', trigger: 'blur' },
    ],
  },
  idcardbRules: {
    issue_authority: [
      { required: true, message: '请填写签发机关', trigger: 'blur' },
      { max: 20, message: '最多仅允许录入20个字符', trigger: 'blur' },
    ],
    issue_date: [
      { required: true, message: '请选择签发日期', trigger: 'change' },
    ],
    expire_date: [
      { required: true, message: '请选择有效期', trigger: 'change' },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/upload/ocr-info/rules.js